import { render, staticRenderFns } from "./subjectAutocomplete.vue?vue&type=template&id=b86a7a2e"
import script from "./subjectAutocomplete.vue?vue&type=script&lang=ts"
export * from "./subjectAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports